define('wanoticelist', ['jquery', 'wanotifications', 'wamessages'], function ($, wanotifications, wamessages) {

    return {
        noticeButtons: $('.js_wanoticelist'),
        noticeListOld: $('.js_wanoticelistOld'),
        headerIcon: $('.header__icon--circle.favourite'),
        headerIconVisibleClassname: "visible",
        deleteBtnClassName: "favourites__delete",
        favViewList: $('#js_favViewList'),
        storageKey: "waoxfavourites",
        onListAttr: "onlist",
        emptyFavouritesListElement: $('#emptyFavouritesListElement').html(),
        deleteFavouritesListElement: $('#deleteFavouritesListElement').html(),
        syncWishlistElement: $('#syncWishlistElement').html(),
        isLoggedIn: false,

        bindEvents: function bindEvents() {
            var _this = this;

            this.noticeButtons.on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                _this.currentAid = e.currentTarget.dataset.aid;
                _this.currentProduct = e.currentTarget.dataset.product;
                _this.setFavourite();
            });
        },
        getWaItems: function getWaItems() {
            if (this.storageKey in localStorage) {
                var data = localStorage.getItem(this.storageKey);

                return data ? JSON.parse(data) : {};
            } else {
                return {};
            }
        },
        setWaItem: function setWaItem(data) {
            return localStorage.setItem(this.storageKey, JSON.stringify(data));
        },
        removeItems: function removeItems() {
            this.setWaItem({});
        },
        setUserMsg: function setUserMsg(msgKey) {
            if (msgKey !== false) wanotifications.msg(wamessages[wamessages.actLang][msgKey], 'success', 1000);
            return true;
        },
        setFavourite: function setFavourite() {
            var currentInstance = this;
            if (this.isLoggedIn) {
                new Ajax.Request(getWishlistDataUrl, {
                    onSuccess: function onSuccess(transport) {
                        var oldData = transport.responseJSON.wishlist_data;

                        if (oldData.hasOwnProperty(currentInstance.currentAid) === true) {
                            new Ajax.Request(deleteProductWishlistUrl, {
                                parameters: {
                                    product_id: currentInstance.currentAid
                                },
                                onSuccess: function onSuccess(deleteTransport) {
                                    currentInstance.buildFavViewUpdated(deleteTransport.responseJSON);
                                }
                            });
                        } else {
                            new Ajax.Request(addProductWishlistUrl, {
                                parameters: {
                                    product_id: currentInstance.currentAid
                                },
                                onSuccess: function onSuccess(addTransport) {
                                    currentInstance.setUserMsg('noticeMsgAdd');
                                    currentInstance.buildFavViewUpdated(addTransport.responseJSON);
                                }
                            });
                        }
                    }
                });
            } else {
                var data = this.getWaItems();

                if (data.hasOwnProperty(this.currentAid) === true) {
                    delete data[this.currentAid];
                } else {
                    data[this.currentAid] = this.currentProduct.replace('"img":""', '"img":"' + $('[data-thumb="0"] img').attr('src') + '"');
                    this.setUserMsg('noticeMsgAdd');
                }
                this.setWaItem(data);
                this.buildFavViewUpdated(this.getWaItems());
            }

            return true;
        },
        bindDelete: function bindDelete() {
            var _this2 = this;

            var deleteButtons = $('.' + this.deleteBtnClassName);
            deleteButtons.on('click', function (e) {
                var self = $(e.currentTarget);
                _this2.currentAid = e.currentTarget.dataset.aid;
                _this2.setFavourite();
                _this2.setUserMsg(false);
            });
        },
        buildFavViewUpdated: function buildFavViewUpdated(waoxfavourites) {
            this.noticeButtons.removeAttr('data-' + this.onListAttr);

            var favouritesLength = Object.keys(waoxfavourites).length;

            favouritesLength > 0 ? this.headerIcon.text(favouritesLength) && this.headerIcon.parent().addClass(this.headerIconVisibleClassname) : this.headerIcon.text(favouritesLength) && this.headerIcon.parent().removeClass(this.headerIconVisibleClassname) && this.setEmptyListNotice();

            for (var key in waoxfavourites) {
                if (waoxfavourites.hasOwnProperty(key)) {
                    $('.js_wanoticelist[data-aid="' + key + '"]').attr('data-' + this.onListAttr, '1');
                }
            }

            if (!this.isLoggedIn && $('#sync-wishlist-message').length) {
                $('#sync-wishlist-message').replaceWith(this.syncWishlistElement);
            }

            if (this.favViewList.length > 0) {
                if (favouritesLength) {
                    // flush list before generating new items
                    this.favViewList.html('');
                }

                for (var key in waoxfavourites) {
                    if (waoxfavourites.hasOwnProperty(key)) {
                        var item = JSON.parse(waoxfavourites[key]);
                        this.favViewList.append('<li class="wishlist-element">\n                                <a href="' + item.link + '">\n                                    <img class="element-image" src="' + item.img + '" alt="">\n                                    <span class="element-name">' + item.name + '</span>\n                                </a>\n                                ' + this.deleteFavouritesListElement.replace('__aid__', key) + '\n                            </li>');
                    }
                }

                this.bindDelete();
            }

            return true;
        },
        buildFavView: function buildFavView() {
            if (this.storageKey in localStorage && this.favViewList.length > 0) {

                this.favViewList.html('');
                this.noticeButtons.removeAttr('data-' + this.onListAttr);

                var waoxfavourites = JSON.parse(this.getWaItems());
                var favouritesLength = Object.keys(waoxfavourites).length;

                favouritesLength > 0 ? this.headerIcon.text(favouritesLength) && this.headerIcon.parent().addClass(this.headerIconVisibleClassname) : this.headerIcon.text(favouritesLength) && this.headerIcon.parent().removeClass(this.headerIconVisibleClassname) && this.setEmptyListNotice();

                for (var key in waoxfavourites) {
                    if (waoxfavourites.hasOwnProperty(key)) {
                        var item = JSON.parse(waoxfavourites[key]);
                        this.favViewList.append('<li>\n                                <a href="' + item.link + '"><img src="' + item.img + '" alt="">\n                                    <span>' + item.name + '</span>\n                                </a>\n                                ' + this.deleteFavouritesListElement.replace('__aid__', key) + '\n                            </li>');
                        $('.js_wanoticelist[data-aid="' + key + '"]').attr('data-' + this.onListAttr, '1');
                    }
                }

                this.bindDelete();
                return true;
            }
        },
        setEmptyListNotice: function setEmptyListNotice() {
            this.favViewList.html(this.emptyFavouritesListElement);
            localStorage.removeItem(this.storageKey);
        },
        syncGuestWishlist: function syncGuestWishlist(oldCustomerData, callback) {
            var currentInstance = this;
            var localData = this.getWaItems();
            if (Object.keys(localData).length === 0) {
                callback(oldCustomerData); // guest data is empty, so we use current wishlist data from customer

                return;
            }

            var productIds = Object.keys(localData);
            new Ajax.Request(syncWishlistUrl, {
                parameters: {
                    product_ids: productIds.join(',')
                },
                onSuccess: function onSuccess(transport) {
                    var response = transport.responseJSON;
                    if (response.status == 1) {
                        // we merged guest data with customer, so we use latest wishlist_data
                        currentInstance.removeItems();
                        callback(response.wishlist_data);
                    }
                }
            });
        },
        syncAndDeleteOldList: function syncAndDeleteOldList() {
            var _this3 = this;

            var oldListElements = $('.product__favourite--old');
            if (!!oldListElements) {
                oldListElements.each(function (i, el) {
                    _this3.currentAid = el.dataset.aid;
                    _this3.currentProduct = el.dataset.product;
                    _this3.setFavourite();
                    var query = JSON.parse(_this3.currentProduct)['query'];
                    setTimeout(function () {
                        $.get(query, function (data) {
                            console.log('item is removed');
                        });
                    }, 1200);
                });
            }
        },
        init: function init() {
            var currentInstance = this;
            if (!currentInstance.emptyFavouritesListElement) {
                return;
            }

            new Ajax.Request(getWishlistDataUrl, {
                onSuccess: function onSuccess(transport) {
                    var response = transport.responseJSON;
                    currentInstance.isLoggedIn = response.is_logged_in;
                    var dataBeforeSync = response.wishlist_data;

                    if (currentInstance.isLoggedIn) {
                        currentInstance.syncGuestWishlist(dataBeforeSync, function (data) {
                            currentInstance.buildFavViewUpdated(data);
                        });
                    } else {
                        currentInstance.buildFavViewUpdated(currentInstance.getWaItems());
                    }
                    currentInstance.bindEvents();
                }
            });
        }
    };
});

